import { render } from "./BomPartTable.vue?vue&type=template&id=2d7b36fd&scoped=true"
import script from "./BomPartTable.vue?vue&type=script&lang=js"
export * from "./BomPartTable.vue?vue&type=script&lang=js"

import "./BomPartTable.vue?vue&type=style&index=0&id=2d7b36fd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7b36fd"]])

export default __exports__